import React, { Component } from 'react';
import {
  PAYPAL_THEME,
  Card,
  BodyText,
  Divider,
  Link,
  Button,
  HeadingText,
} from '@paypalcorp/pp-react';
import { Dialog } from '@paypalcorp/pp-react-modal';
import DonationModal from '../DonationModal';
import uniq from 'lodash/uniq';
import styles from './charityCard.less';
import * as analytics from '../../lib/analytics';
import SheetTrigger from '../SheetTrigger';
import MediaQuery from 'react-responsive';

export default class CharityCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  charityCategories(categories) {
    // display categories in one line, append with ... when the total category string length is beyond 28
    return (
      <BodyText
        size='sm'
        clampAtLine={1}
        className={styles.categoryDisplay}
        style={{ color: PAYPAL_THEME.sysColorBackgroundMediumContrast }}
      >
        {categories.join(', ')}
      </BodyText>
    );
  }

  closeDonationModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleLearnMoreAnalytics = (event, linkName, npid) => {
    analytics.trackLinkWithData(
      linkName,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  handleDonateLinkClick = (event, charity, linkName) => {
    this.setState({
      isOpen: true,
    });
    analytics.trackLinkWithData(
      linkName,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: charity.nonprofit_id },
      'link'
    );
  };

  renderDonateLink = (charity) => {
    if (!this.props.gtgEnabled) {
      return (
        <Button
          tabIndex='0'
          role='link'
          onClick={(e) => this.handleDonateLinkClick(e, charity, 'donateLink')}
          size='sm'
          fullWidthOnMobile={false}
          id={`nemoCharityCardDonation_${this.props.testId}`}
        >
          {this.props.i18n('label.donate-link')}
        </Button>
      );
    }
    return (
      <Link
        tabIndex='0'
        onClick={(e) => this.handleDonateLinkClick(e, charity, 'donateLink')}
        id={`nemoCharityCardDonation_${this.props.testId}`}
        size='sm'
        fullWidthOnMobile={false}
      >
        {this.props.i18n('label.donate-link')}
      </Link>
    );
  };

  renderDonateComponent = (charity) => {
    return (
      <>
        <MediaQuery minWidth={601}>{this.renderDonateLink(charity)}</MediaQuery>
        <MediaQuery maxWidth={600}>
          <SheetTrigger TriggerComponent={this.renderDonateLink(charity)}>
            <div style={{ margin: '1rem' }}>
              <DonationModal
                i18n={this.props.i18n}
                charity={charity}
                campaignInfo={this.props.campaignInfo}
                enable={this.props.enable}
                isMobile={this.props.isMobile}
                fptiInfo={this.props.fptiInfo}
                csrf={this.props.csrf}
                cdnHost={this.props.cdnHost}
              />
            </div>
          </SheetTrigger>
        </MediaQuery>
      </>
    );
  };

  render() {
    const charity = this.props.charity;
    let categories = [];
    if (Array.isArray(charity.cause_area)) {
      categories =
        uniq(
          charity.cause_area.map((causeArea) =>
            this.props.i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }
    const charityCardContent = charity.admin_impactStmt
      ? charity.admin_impactStmt
      : charity.description;

    const removeDonateLink =
      this.props.campaignState === 'SUSPENDED' ||
      this.props.campaignState === 'INACTIVE';

    let donationModal = (
      <Dialog
        isOpen={this.state.isOpen}
        onClose={this.closeDonationModal}
        id={'charityCardModal'}
      >
        <DonationModal
          i18n={this.props.i18n}
          charity={charity}
          campaignInfo={this.props.campaignInfo}
          enable={this.props.enable}
          isMobile={this.props.isMobile}
          fptiInfo={this.props.fptiInfo}
          csrf={this.props.csrf}
          cdnHost={this.props.cdnHost}
        />
      </Dialog>
    );

    return (
      <div>
        <Card card>
          <Card.Header className={styles.tileHeader}>
            <div className={styles.headerContainer}>
              <div
                className={styles.cardImage}
                style={{
                  background: `url(${charity.logo_url}) no-repeat center, center`,
                  backgroundSize: 'contain',
                }}
              />
              <div className={styles.headerContent}>
                <BodyText size='sm' regular>
                  {charity.name}
                </BodyText>
                {this.charityCategories(categories)}
              </div>
            </div>
          </Card.Header>
          <Divider secondary />
          <Card.Content className={styles.charityCardContent}>
            <BodyText
              className={styles.charityDescClamp}
              style={{ color: PAYPAL_THEME.sysColorBackgroundMediumContrast }}
            >
              {charityCardContent}
            </BodyText>
          </Card.Content>
          <Card.Footer className={styles.cardFooter}>
            {!removeDonateLink && this.renderDonateComponent(charity)}
            {this.state.isOpen && donationModal}
            <Link
              onClick={(e) =>
                this.handleLearnMoreAnalytics(
                  e,
                  'learnMore',
                  charity.nonprofit_id
                )
              }
              target='_blank'
              href={`/fundraiser/${this.props.campaignInfo.id}/charity/${charity.nonprofit_id}`}
            >
              {this.props.i18n('label.visit-page')}
            </Link>
          </Card.Footer>
        </Card>
      </div>
    );
  }
}
